<template>
  <div class="student-upload-container">
    <div class="page-header mb-4">
      <div class="breadcrumb mb-2">ນັກຮຽນ / <span>ນຳເຂົ້າຂໍ້ມູນຜ່ານ Excel</span></div>
      <div class="header-content">
        <h1 class="mb-1">ນຳເຂົ້າຂໍ້ມູນນັກຮຽນ</h1>
        <p class="mb-0 text-muted">ອອກລະຫັດນັກຮຽນ ແລະ ນຳເຂົ້າຂໍ້ມູນຜ່ານໄຟລ໌ Excel ຢ່າງເປັນລະບົບ</p>
      </div>
    </div>

    <div class="panel shadow-sm mb-4">
      <div class="card-header header-gradient text-white p-4 text-center">
        <i class="fas fa-file-excel fa-3x mb-3"></i>
        <h3 class="font-weight-bold text-white mb-2">Student ID Generator & Excel Upload</h3>
        <p class="mb-0 opacity-80 text-white">ກະລຸນາເລືອກໄຟລ໌ Excel ທີ່ມີຂໍ້ມູນນັກຮຽນຕາມຮູບແບບທີ່ກຳນົດ</p>
      </div>
      <div class="panel-body p-4">
        <div class="d-flex justify-content-end mb-4 text-center">
          <button variant="primary" size="sm" class="font-weight-bold" @click="downloadTemplate">
            <i class="fas fa-file-download mr-1"></i>
            ດາວໂຫລດ Template Excel
          </button>
        </div>

        <div class="upload-section text-center">
          <label class="upload-dropzone" :class="{ 'has-items': items.length > 0 }">
            <input type="file" @change="handleFileUpload" accept=".xlsx, .xls" class="d-none" />
            <div class="upload-content">
              <i class="fas fa-3x mb-3" :class="items.length ? 'fa-check-circle text-success' : 'fa-cloud-upload-alt text-primary'"></i>
              <h5 v-if="!items.length" class="text-muted mb-0">ຄລິກບ່ອນນີ້ເພື່ອເລືອກໄຟລ໌ Excel (.xlsx)</h5>
              <h5 v-else class="text-success font-weight-bold mb-0">ກວດພົບຂໍ້ມູນ {{ items.length }} ລາຍການ ພ້ອມນຳເຂົ້າ</h5>
            </div>
          </label>
        </div>
      </div>
    </div>

    <div v-if="items.length" class="panel shadow-sm mb-5">
      <div class="panel-head d-flex justify-content-between align-items-center">
        <h3 class="mb-0">ລາຍການຂໍ້ມູນທີ່ກວດສອບພົບ</h3>
        <button variant="primary" size="md" class="btn-save px-4 shadow-sm" @click="onUpload" :disabled="submitting">
          <b-spinner v-if="submitting" small class="mr-2"></b-spinner>
          <i v-else class="fas fa-cloud-upload-alt mr-2"></i>
          {{ submitting ? 'ກຳລັງບັນທຶກ...' : 'ຢືນຢັນການບັນທຶກລົງຖານຂໍ້ມູນ' }}
        </button>
      </div>
      <div class="panel-body p-0">
        <div class="table-wrap">
          <table class="table table-hover align-middle mb-0">
            <thead class="thead-light">
                <tr>
                  <th>EMIS Code</th>
                  <th>ປີ</th>
                  <th>ແຂວງ/ເມືອງ</th>
                  <th>Serial ID</th>
                  <th>Student ID</th>
                  <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                  <th>ວັນເດືອນປີເກີດ</th>
                  <th>ເພດ</th>
                  <th>ໂຮງຮຽນ</th>
                  <th>ຊັ້ນຮຽນ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(student, index) in items" :key="index">
                  <td>{{ student.school_id }}</td>
                  <td class="text-center">{{ student.yearEntryCode }}</td>
                  <td>
                    <div class="small font-weight-bold text-primary mb-1">{{ student.provinceCode }}</div>
                    <div class="small text-muted">{{ student.districtCode }}</div>
                  </td>
                  <td>{{ student.serialId }}</td>
                  <td><span class="student-id-badge">{{ student.student_id }}</span></td>
                  <td class="lao-font">
                    <div class="font-weight-bold mb-1">{{ student.firstNameLao }}</div>
                    <div class="text-muted small">{{ student.familyNameLao }}</div>
                  </td>
                  <td>{{ student.dob }}</td>
                  <td class="text-center">
                    <p pill :class="['gender-badge', student.Gender_Code == 1 ? 'male' : 'female']">
                      <i :class="['fas', student.Gender_Code == 1 ? 'fa-mars' : 'fa-venus', 'mr-1']"></i>
                      {{ student.gender }}
                    </p>
                  </td>
                  <td class="small">{{ student.school_name }}</td>
                  <td><p variant="light" class="border px-2">{{ student.grade }}</p></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
   
</template>

<style scoped>
.student-upload-container {
  animation: fadeIn 0.4s ease-out;
  max-width: 1300px;
  margin: 0 auto;
  font-family: 'Noto Sans Lao', 'Phetsarath OT', sans-serif;
}

@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
@keyframes fadeInSimple { from { opacity: 0; } to { opacity: 1; } }
@keyframes slideDown { from { transform: translateY(-20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

.page-header { margin-bottom: 24px; }
.page-header h1 { font-size: 24px; font-weight: 700; color: #0D1B2A; }
.page-header p { color: #4A5568; font-size: 14px; margin-top: 4px; }
.breadcrumb { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #8898AA; margin-bottom: 8px; background: none; padding: 0; }
.breadcrumb span { color: #003F8A; font-weight: 600; }

.panel { background: #FFFFFF; border: 1px solid #E2E8F0; border-radius: 12px; overflow: hidden; }
.panel-head { padding: 16px 20px; border-bottom: 1px solid #E2E8F0; background: #fff; }
.panel-head h3 { font-size: 16px; font-weight: 600; color: #0D1B2A; margin: 0; }
.panel-body { padding: 20px; }

.header-gradient {
  background: linear-gradient(135deg, #003f8a 0%, #0056b3 100%);
  color: white;
}

.upload-section {
  max-width: 800px;
  margin: 0 auto;
}

.upload-dropzone {
  display: block;
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  padding: 40px;
  cursor: pointer;
  background: white;
  transition: all 0.3s ease;
}

.upload-dropzone:hover {
  border-color: #003f8a;
  background: #f1f5f9;
  transform: translateY(-2px);
}

.upload-dropzone.has-items {
  border-color: #10b981;
  background: #f0fdf4;
}

.btn-save {
  background: #003F8A;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  transition: 0.3s;
}

.gender-badge { padding: 6px 14px; font-weight: 600; display: inline-flex; align-items: center; font-size: 11px; text-transform: uppercase; border: none; }
.gender-badge.male { background-color: #003f8a !important; color: white; }
.gender-badge.female { background-color: #e91e63 !important; color: white; }

.thead-light th {
  background-color: #f1f5f9;
  color: #475569;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  border: none;
}

.student-id-badge {
  background-color: #003f8a;
  color: white;
  padding: 4px 12px;
  border-radius: 50px;
  font-family: 'Times New Roman', serif;
  font-weight: 600;
  font-size: 0.9rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
</style>

<script>
import * as XLSX from 'xlsx';
import api from '@/utils/api';
const generateStudentID = (data) => {
    const { ISO_Code, Year_Entry_Code, Province_Code, District_Code, Serial_ID } = data;
    // Format: LA251302000001
    const baseId = `${ISO_Code}-${Province_Code}${District_Code}-${Year_Entry_Code}-${Serial_ID.toString().padStart(6, '0')}`;

    // Calculate Check Digit (Luhn Mod 10)
    const checkDigit = calculateLuhn(baseId.replace(/\D/g, ''));
    return `${baseId}-${checkDigit}`;
};

function calculateLuhn(numberStr) {
    let sum = 0;
    let shouldDouble = true; // Start doubling from the rightmost payload digit
    for (let i = numberStr.length - 1; i >= 0; i--) {
        let digit = parseInt(numberStr.charAt(i));
        if (shouldDouble) {
            digit *= 2;
            if (digit > 9) digit -= 9;
        }
        sum += digit;
        shouldDouble = !shouldDouble;
    }
    return (10 - (sum % 10)) % 10;
}


export default {
  created () {
    // ປັບໃຫ້ກົງກັບ HomePage.vue ທີ່ໃຊ້ 'user-info'
    let userInfo = localStorage.getItem("user-info") || localStorage.getItem("Login");
    try {
      this.user = JSON.parse(userInfo);
    } catch (e) {
      this.user = null;
    }
  },
    data() {
        return {
            submitting: false,
            students: [],
            items: [],
            user: null
        };
    },
    methods: {
        showCustomModal(title, message, type = 'success') {
            const icon = type === 'success' ? 'fa-check-circle' : 'fa-exclamation-triangle';
            const iconColor = type === 'success' ? '#10b981' : '#ef4444';
            const btnColor = type === 'success' ? '#003f8a' : '#ef4444';

            const overlay = document.createElement('div');
            overlay.id = 'custom-alert-overlay';
            Object.assign(overlay.style, {
                position: 'fixed', top: '0', left: '0', width: '100%', height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.4)', backdropFilter: 'blur(8px)',
                display: 'flex', justifyContent: 'center', alignItems: 'center',
                zIndex: '10000', animation: 'fadeInSimple 0.3s ease'
            });

            const card = document.createElement('div');
            Object.assign(card.style, {
                backgroundColor: 'white', padding: '30px', borderRadius: '16px',
                boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)', maxWidth: '400px',
                width: '90%', textAlign: 'center', animation: 'slideDown 0.3s ease'
            });

            card.innerHTML = `
                <div style="color: ${iconColor}; font-size: 56px; margin-bottom: 20px;">
                    <i class="fas ${icon}"></i>
                </div>
                <h2 style="margin: 0 0 15px; color: #1e293b; font-size: 1.25rem; font-family: 'Phetsarath OT'">${title}</h2>
                <p style="margin: 0 0 25px; color: #64748b; line-height: 1.6; font-family: 'Phetsarath OT'">${message}</p>
                <div style="display: flex; justify-content: center;">
                    <button id="btn-custom-ok" style="padding: 10px 40px; border: none; background: ${btnColor}; color: white; border-radius: 8px; cursor: pointer; font-weight: 600; font-family: 'Phetsarath OT'">ຕົກລົງ</button>
                </div>
            `;

            overlay.appendChild(card);
            document.body.appendChild(overlay);

            document.getElementById('btn-custom-ok').onclick = () => {
                document.body.removeChild(overlay);
            };
        },
         onUpload(event) {
            event.preventDefault();
            if (!this.items.length) return;
            
            if (!this.user) {
              this.showCustomModal("ແຈ້ງເຕືອນ", "ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່", "error");
              return;
            }
           
            this.submitting = true;
            let rp_data = null;
            let postsdata = {
                table: "students",
                rows: this.items,
            };
            api.post("/insertMany", postsdata)
                .then((rep) => {
                    rp_data = rep.data;
                    if (rp_data.msg == "Done") {
                        this.showCustomModal("ສຳເລັດ", rp_data.desc, "success");
                        this.items = []; // ລ້າງຂໍ້ມູນຫຼັງຈາກບັນທຶກສຳເລັດ
                    } else {
                        this.showCustomModal("ຜິດພາດ", rp_data.desc, "error");
                    }
                })
                .catch((error) => {
                    this.showCustomModal("ຂໍ້ຜິດພາດສາຍສົ່ງ", "ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບ Server ໄດ້: " + error.message, "error");
                })
                .finally(() => {
                    this.submitting = false;
                });

        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) return;

            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                // ດຶງ Headers ຈາກແຖວທຳອິດຂອງ Excel
                const headers = XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0];
                const expectedHeaders = [
                    "School_Code", "School_Name", "Year_Entry_Code", "Province_Code", 
                    "District_Code", "Serial_ID", "Name", "Family_Name", "DOB", 
                    "Gender_Code", "Gender", "Grade_Code", "Grade", "accd","district_id"
                ];

                // ກວດສອບຫາ Headers ທີ່ຫາຍໄປ
                const missingHeaders = expectedHeaders.filter(h => !headers || !headers.includes(h));

                if (missingHeaders.length > 0) {
                    this.showCustomModal(
                        "ຮູບແບບໄຟລ໌ບໍ່ຖືກຕ້ອງ", 
                        `ກະລຸນາໃຊ້ Template ທີ່ລະບົບກຳນົດໃຫ້. ຖັນທີ່ຫາຍໄປ: ${missingHeaders.join(", ")}`, 
                        "error"
                    );
                    this.items = [];
                    event.target.value = ''; // Reset input file
                    return;
                }

                const json = XLSX.utils.sheet_to_json(worksheet);

                this.students = json.map((row) => ({
                    ...row,
                    generatedId: generateStudentID({
                        ISO_Code: 'LA',
                        Year_Entry_Code: row.Year_Entry_Code,
                        Province_Code: row.Province_Code,
                        District_Code: row.District_Code,
                        Serial_ID: row.Serial_ID,
                       
                    })
                }));
                this.items = this.students.map(student => ({
                    "emis_code": student.School_Code,
                     "school_id": student.School_Code,
                     "school_name": student.School_Name,
                    "student_id": student.generatedId,
                    "firstNameLao": student.Name,
                    "familyNameLao": student.Family_Name,
                    "dob": student.DOB,
                    "Gender_Code": parseInt(student.Gender_Code),
                    "gender": student.Gender,
                    "nameEnglish": "",
                    "familyNameEnglish": "",
                    "Grade_Code": parseInt(student.Grade_Code),
                    "grade": student.Grade,
                    "yearEntryCode": student.Year_Entry_Code,
                    "provinceCode": student.Province_Code,
                    "districtCode": student.District_Code,
                    "serialId": student.Serial_ID,
                    "accd": student.accd,
                    "district_id":  student.district_id   || "0000"
                    
                }));
            };
            reader.readAsArrayBuffer(file);
        },
        downloadTemplate() {
            const header = [
                "School_Code", "School_Name", "Year_Entry_Code", "Province_Code", 
                "District_Code", "Serial_ID", "Name", "Family_Name", "DOB", 
                "Gender_Code", "Gender", "Grade_Code", "Grade", "accd", "district_id"
            ];
            const sampleData = [{
                School_Code: "10101001",
                School_Name: "ໂຮງຮຽນຕົວຢ່າງ",
                Year_Entry_Code: "25",
                Province_Code: "13",
                District_Code: "02",
                Serial_ID: "000001",
                Name: "ສົມຊາຍ",
                Family_Name: "ດີເດັດ",
                DOB: "2010-01-01",
                Gender_Code: 1,
                Gender: "ຊາຍ",
                Grade_Code: 1,
                Grade: "ປ.1",
                accd: "2024-2025",
                district_id: "1302"
            }];
            const worksheet = XLSX.utils.json_to_sheet(sampleData, { header });
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
            XLSX.writeFile(workbook, "student_upload_template.xlsx");
        }
    }
};
</script>
